import { range, map, findIndex, filter, every, isNil } from 'lodash';

export default {
  config: (state) => state.config,
  gameTitle: (state, getters) => {
    if (!isNil(getters.customProductName)) {
      return getters.customProductName;
    }
    return getters.translateProductName
      ? getters.translations[state.usePackageTranslations ? 'product_name' : 'general_productName_luckyX']
      : 'Lucky X';
  },
  customProductName: (state) => state.config.ui?.config?.customProductName,
  translateProductName: (state) => state.config.ui?.config?.translateProductName,
  activeGameLayout: (state) => state.gameLayout,
  isAudioOn: (state) => state.isAudioOn,
  bingoNumbers: (state, getters) => {
    const numbers = range(state.bettingRules.minBingoNumber, state.bettingRules.maxBingoNumber + 1);
    return map(numbers, (number) => {
      const color = getters.getNumberColor(number);
      return {
        hex: color,
        value: number,
        isSelected: findIndex(getters.selectedBingoNumbers, (n) => n.number === number) > -1,
      };
    });
  },
  getNumberColor: (state) => (number) => {
    const colors = state.bettingRules.bingoColors;
    return colors[(number - 1) % colors.length];
  },
  firstBallColor: (state) => state.config.bets[22],
  specialBetEnabled: (state) => (id) => {
    const specialBet = state.specialBets.find((bet) => bet.id === id);
    return specialBet ? specialBet.value : false;
  },
  getSpecialBet: (state) => (id) => state.specialBets.find((bet) => bet.id === id),
  specialBetsEnabled: (state) => {
    return !!state.specialBets.filter((bet) => bet.value).length;
  },
  regulatoryMessageText: (state) => state.config.ui.config.regulatoryMessage,
  isIsonis: (state) => state.isonisList.indexOf(state.config.taxAuthority) > -1,
  isBoostActive: (state) => state.config.ui.config?.boost?.enabled || false,
  isVisualizationV2Active: (state) => state.config.ui.config?.luckyxV2visualization ?? state.visualizationV2Enabled,
  ajsDisabled: (state) => state.config?.ui?.config?.ajsDisabled ?? false,
  // Getters needed by the betslip
  isBettingDisabled: (state) => state.isBettingDisabled,
  isTerminalLayout: (state) => state.layout === 'terminal',
  isTerminalChannel: (state) => state.config.applicationName?.toLowerCase() === 'terminal',
  mode: (state) => state.config.ui.config.mode || 'fullWeb',
  userIsOperator: (state) =>
    state.terminalUserData.userType === 'OPERATOR' || state.terminalUserData.type === 'OPERATOR',
  getTranslation: (state) => (key) => state.translations.translations[key] || key,
  systemBetsDisabled: (state) => {
    const { bets } = state.config;
    const systemBets = filter(bets, (bet) => bet.betType === 'System');
    return every(systemBets, ['value', false]);
  },
  isExpandedLayout: (state) => state.gameLayout === 'Expanded',
  isFreeBetMode: () => null,
  isNextGen: (state) => state.config.platformName === 'NextGen',
  theme: (state) => state.config?.ui?.config?.theme,
  freeBetFeatureActive: (state) => state.config.ui.config.freeBetFeatureActive,
  customDomain: (state) => state.config.customDomain,
  roundId: (state) => state.roundId, // For games betslip rebet
};
